"use strict";

import { Collection } from "Collection";
import { FormFieldsModel } from 'Models/FormFieldsModel';
import { Objects } from "Constants/objects";
export var FormFieldsCollection = Collection.extend({
  model: FormFieldsModel,
  object: Objects.SysFormFields
});